import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
const purchases = [{
  name: 'Martín G.',
  city: 'Buenos Aires'
}, {
  name: 'Lucía R.',
  city: 'Córdoba'
}, {
  name: 'Santiago M.',
  city: 'Rosario'
}, {
  name: 'Valentina P.',
  city: 'Mendoza'
}, {
  name: 'Nicolás F.',
  city: 'La Plata'
}, {
  name: 'Camila D.',
  city: 'Tucumán'
}, {
  name: 'Facundo L.',
  city: 'Mar del Plata'
}, {
  name: 'Sofía A.',
  city: 'Salta'
}, {
  name: 'Tomás B.',
  city: 'Santa Fe'
}, {
  name: 'Carolina V.',
  city: 'Neuquén'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialDelay = setTimeout(() => {
      if (!dismissed) setVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible || dismissed) return;
    // Show next popup after random interval (15-25 seconds)
    const nextDelay = Math.floor(Math.random() * 10000) + 15000;
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, nextDelay);
    return () => clearTimeout(showTimer);
  }, [visible, currentIndex, dismissed]);
  const current = purchases[currentIndex];
  const minutesAgo = Math.floor(Math.random() * 12) + 1;
  if (dismissed) return null;
  return <AnimatePresence data-id="element-206">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-4 left-4 right-4 sm:right-auto sm:left-6 sm:bottom-6 z-50 sm:max-w-xs" data-id="element-207">
          <div className="bg-surface border border-border rounded-xl p-4 shadow-2xl shadow-black/40 relative" data-id="element-208">
            <button onClick={() => {
          setVisible(false);
          setDismissed(true);
        }} className="absolute top-2 right-2 text-text-muted hover:text-text-secondary transition-colors" aria-label="Cerrar" data-id="element-209">
              <X className="w-3.5 h-3.5" data-id="element-210" />
            </button>

            <div className="flex items-start gap-3 pr-4" data-id="element-211">
              <div className="w-9 h-9 rounded-full bg-accent/15 flex items-center justify-center shrink-0 mt-0.5" data-id="element-212">
                <CheckCircle className="w-5 h-5 text-accent" data-id="element-213" />
              </div>
              <div data-id="element-214">
                <p className="font-heading font-bold text-text-primary text-sm leading-snug" data-id="element-215">
                  {current.name}
                  <span className="font-body font-normal text-text-secondary" data-id="element-216">
                    {' '}
                    de {current.city}
                  </span>
                </p>
                <p className="font-body text-xs text-text-secondary mt-0.5" data-id="element-217">
                  Compró el manual hace {minutesAgo} min
                </p>
                <p className="font-body text-[10px] text-accent/70 uppercase tracking-wider font-semibold mt-1" data-id="element-218">
                  ✓ Compra verificada
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}